// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";

// export const PharmacyOrderDetails: React.FC<any> = React.memo((props) => {
//   const { control, register, handleSubmit } = useForm();

//   const params = useParams();
//   const id = params?.id;
//   const onSubmit = () => {};

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { Orders: "pharmacy-orders/list" },
//       {
//         [!id ? "Order Details" : ""]: "/",
//       },
//     ]);
//   }, [id]);

//   const steps = [
//     { label: "Order Placed", completed: true, icon: <WSIcons.FiPackage /> },
//     {
//       label: "Delivery Assigned",
//       completed: true,
//       icon: <WSIcons.TbUserSquareRounded />,
//     },
//     {
//       label: "Sample Collected",
//       completed: true,
//       icon: <WSIcons.RiRidingLine />,
//     },
//     {
//       label: "Report Uploaded",
//       completed: true,
//       icon: <WSIcons.BsArrowUpSquare />,
//     },
//   ];
//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/pharmacy-orders/list"} />
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Order Timeline
//             </Typography>
//           </Grid>
//           <Grid item sm={12} xs={12}>
//             <WSHorizontalTimeline steps={steps} />
//           </Grid>
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} mt={2}>
//           <Grid item sm={4} xs={12}>
//             <Typography>Order ID</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>Status</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>Action</Typography>
//           </Grid>{" "}
//           <Grid item xs={12}>
//             <Divider style={{ marginTop: 10 }} />
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography>#ygghj</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("status")}
//               id="status"
//               control={control}
//               label=""
//               name="status"
//               isInGridFilter={false}
//               options={config.statusConfig.staticOptionData}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("action")}
//               id="action"
//               control={control}
//               label=""
//               name="action"
//               isInGridFilter={false}
//               options={config.statusConfig.staticOptionData}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <Grid
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 1,
//                 bgcolor: "#DDF6EC",
//                 borderRadius: 2,
//                 minWidth: 160,
//                 justifyContent: "center",
//               }}
//             >
//               <Grid
//                 sx={{
//                   color: "#33B78E",
//                   fontSize: 20,
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <WSIcons.VisibilityIcon />
//               </Grid>

//               <Typography
//                 sx={{
//                   fontSize: 14,
//                   fontWeight: 600,
//                   color: "#1E8A67",
//                 }}
//               >
//                 Delivery Report
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>
//       <Grid container spacing={2} mt={2}>
//         <Grid item xs={12} sm={6}>
//           <Paper
//             elevation={0}
//             style={{
//               paddingLeft: 20,
//               paddingRight: 20,
//               marginTop: 0,
//               paddingBottom: 25,
//               borderRadius: "8px",
//             }}
//           >
//             <Grid container spacing={2} mt={0}>
//               <Grid item sm={12} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                   Patient Information
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Patient Name
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Kiran{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Age
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 50{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Contact Number
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 96946665{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Address
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : First line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   second line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   third line{" "}
//                 </Typography>
//                 <Typography variant="body2" color={"GrayText"}>
//                   fourth line{" "}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Patient ID
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : PNT-545
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Paper
//             elevation={0}
//             style={{
//               paddingLeft: 20,
//               paddingRight: 20,
//               marginTop: 0,
//               paddingBottom: 25,
//               borderRadius: "8px",
//               height: "19rem",
//             }}
//           >
//             <Grid container spacing={2} mt={0}>
//               <Grid item sm={12} xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                   Order Information
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Total Items
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : 3
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Sub Total
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : ₹480
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Delivery Fee
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : ₹25
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Payment
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Paid
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   Items Name
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={7}>
//                 <Typography variant="body2" color={"GrayText"}>
//                   : Bandage, Sunscreen, Hair Shamboo
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 40,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Report Status
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Divider />
//           </Grid>{" "}
//           <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color={"GrayText"} mt={3}>
//               Report
//             </Typography>
//           </Grid>
//           <Grid item sm={6} xs={12}>
//             <WSFileUpload
//               name="galleryImages"
//               label=""
//               control={control}
//               rules={{ required: false }}
//               acceptFileTypes=".jpg,.jpeg,.png"
//               maxFileSizeMB={2}
//               //  defaultValue={defaultImg}
//               id={"galleryImages"}
//               image={true}
//               align="Start"
//               isToolTipImg={false}
//               multiple={true}
//             />
//           </Grid>
//           {/* <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Turn Around Time
//             </Typography>
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : 12 hours
//             </Typography>
//           </Grid> */}
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 40,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//               Delivery Details
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Divider />
//           </Grid>{" "}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Assigned Technician :
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="test"
//               name="test"
//               rules={{ required: true }}
//               label=""
//             />
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("assigned")}
//               id="assigned"
//               control={control}
//               label=""
//               name="assigned"
//               options={config.statusConfig.staticOptionData}
//               sx={{ mt: 2, width: 150 }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Status :
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("collected")}
//               id="collected"
//               control={control}
//               label=""
//               name="collected"
//               options={config.statusConfig.staticOptionData}
//               sx={{ mt: 2, width: 150 }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Order ID
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : HC115564
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Order Received Date & Time
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : 3/06/2025 09:30 - 10:00 PM
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="location"
//               name="location"
//               rules={{ required: true }}
//               label=""
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               Delivery Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <Typography variant="body2" color={"GrayText"} mt={2}>
//               : Flat No. 202, Green Heights Apartments, Sector 45, Gurugram,
//               Haryana – 122003
//             </Typography>
//           </Grid>
//         </Grid>
//       </Paper>
//       <Grid item xs={12} sm={6} mt={3}>
//         <Paper
//           elevation={0}
//           style={{
//             paddingLeft: 20,
//             paddingRight: 20,
//             marginTop: 0,
//             paddingBottom: 25,
//             borderRadius: "8px",
//             height: "19rem",
//           }}
//         >
//           <Grid container spacing={2} mt={0}>
//             <Grid item sm={12} xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
//                 Payment Information
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Payment Status
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : Paid
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Order Price
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : 480/-
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Delivery Price
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : 80/-
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Cash or Online
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 : Cash
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color={"GrayText"} mt={2}>
//                 Invoice
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body2" style={{ color: "#098963" }} mt={2}>
//                 : Download
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>
//       </Grid>
//     </>
//   );
// });








// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { useForm, UseFormReturn } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";

// // Updated TypeScript Interfaces to match actual API response
// interface Timeline {
//   orderPlaced: string;
//   deliveryAssigned: string | null;
//   orderShipped: string | null;
//   delivered: string | null;
//   status: string;
//   technician: string;

// }

// interface Patient {
//   username: string;
//   contactNumber: string;
//   address: string;
// }

// interface OrderInfo {
//   totalItems: number;
//   subtotal: number;
//   deliveryFee: number;
//   payment: string;
//   itemsName: string;
// }

// interface DeliveryDetails {
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
//   orderId: string;
//   receivedDateTime: string | null;
//   locationUrl: string | null;
//   deliveryAddress: string;
// }

// interface PaymentInfo {
//   paymentStatus: string;
//   orderPrice: number;
//   deliveryPrice: number;
//   paymentMode: string;
//   invoiceUrl: string;
// }

// interface OrderData {
//   timeline: Timeline;
//   patient: Patient;
//   orderInfo: OrderInfo;
//   report: any | null;
//   deliveryDetails: DeliveryDetails;
//   paymentInfo: PaymentInfo;
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: OrderData;
// }

// // Extended FormData to include galleryImages for file upload
// interface FormData {
//   status: string;
//   action: string;
//   assigned: string;
//   collected: string;
//   test: string;
//   location: string;
//   galleryImages?: FileList | null;
// }

// export const PharmacyOrderDetails: React.FC = React.memo(() => {
//   const methods = useForm<FormData>({
//     defaultValues: {
//       status: "",
//       action: "",
//       assigned: "",
//       collected: "",
//       test: "",
//       location: "",
//       galleryImages: undefined
//     }
//   });
  
//   const { control, register, handleSubmit, setValue, reset } = methods;
//   const navigate = useNavigate();
//   const params = useParams<{ id: string }>();
//   const id = params?.id;

//   const [orderData, setOrderData] = useState<OrderData | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [error, setError] = useState<string>("");

//   // Fetch order data by ID - UPDATED API ENDPOINT
//   const fetchOrderData = useCallback(async () => {
//     if (!id) {
//       setError("No order ID provided");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       // Updated API endpoint to match requirement
//       const response: ApiResponse = await callAPI(`pharmacy/Ph_Order_/order-details/${id}`, Method.GET);
//       console.log("the api response is csvb ", response);
      
//       if (response?.status && response?.data) {
//         setOrderData(response.data);
//         // Populate form with initial values
//         setTimeout(() => {
//           setValue("status", response.data.timeline.status);
//           setValue("location", response.data.deliveryDetails.deliveryAddress);
//         }, 100);
//       } else {
//         setError("Order not found");
//       }
//     } catch (err) {
//       console.error("Error fetching order:", err);
//       setError("Failed to fetch order details");
//     } finally {
//       setLoading(false);
//     }
//   }, [id, setValue]);

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { Orders: "pharmacy-orders/list" },
//       { [`Order #${id?.slice(-6).toUpperCase()}`]: `/pharmacy-orders/${id}` },
//     ]);
//   }, [id]);

//   const onSubmit = async (data: FormData) => {
//     try {
//       // Update order status - Note: Update endpoint may need verification
//       const updateResponse = await callAPI(`pharmacy/Ph_Order_/order-details/${id}`, Method.PUT, data);
//       if (updateResponse.status) {
//         alert("Order updated successfully!");
//         fetchOrderData(); // Refresh data
//       }
//     } catch (error) {
//       console.error("Update failed:", error);
//       alert("Failed to update order");
//     }
//   };

//   // Dynamic timeline based on tracking
//  const timelineSteps = useMemo(() => {
//   const timelineData = orderData?.timeline;
//   const currentStatus = timelineData?.status?.toLowerCase() || "pending";
  
//   console.log("🔍 TIMELINE DEBUG:", {
//     status: timelineData?.status,
//     orderPlaced: !!timelineData?.orderPlaced,
//     deliveryAssigned: !!timelineData?.deliveryAssigned,
//     orderShipped: !!timelineData?.orderShipped,
//     delivered: !!timelineData?.delivered
//   });

//   // ✅ FIXED: If status = "delivered/completed", ALL PREVIOUS STEPS = GREEN
//   const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
//   const isShipped = currentStatus.includes("shipped") || isDelivered;
//   const isAssigned = currentStatus.includes("assigned") || isShipped;
  
//   return [
//     { 
//       label: "Order Placed", 
//       completed: !!timelineData?.orderPlaced || isAssigned,  // ✅ Always true if assigned+
//       icon: <WSIcons.FiPackage /> 
//     },
//     { 
//       label: "Delivery Assigned", 
//       completed: !!timelineData?.deliveryAssigned || isAssigned,  // ✅ FIXED: Shows GREEN
//       icon: <WSIcons.TbUserSquareRounded /> 
//     },
//     { 
//       label: "Order Shipped", 
//       completed: !!timelineData?.orderShipped || isShipped,  // ✅ FIXED: Shows GREEN  
//       icon: <WSIcons.RiRidingLine /> 
//     },
//     { 
//       label: "Delivered", 
//       completed: !!timelineData?.delivered || isDelivered,  // ✅ Current status
//       icon: <WSIcons.BsArrowUpSquare /> 
//     },
//   ];
// }, [orderData]);




//   // Items list for display
//   const itemsList = orderData?.orderInfo?.itemsName || "";

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//          <Typography>Loading order details...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (error || !orderData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//          <Typography color="error">{error}</Typography>
//         </Paper>
//       </>
//     );
//   }

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

//       {/* Timeline Section */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <WSHorizontalTimeline steps={timelineSteps} />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Order Summary */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2} mt={2}>
//           <Grid item sm={4} xs={12}>
//             <Typography variant="body2" color="GrayText">Order ID</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <Typography variant="body2" color="GrayText">Technician Status</Typography>
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <Typography variant="body2" color="GrayText">Delivery status</Typography>
//           </Grid>
//           <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
          
//           <Grid item sm={4} xs={12}>
//             <Typography fontWeight="bold">#{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography>
//           </Grid>
//           <Grid item sm={4} xs={12}>
//             <WSTextField
//              control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
             
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item sm={2} xs={12}>
//             <WSTextField
//                control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "131px" }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <Grid sx={{
//               display: "flex", alignItems: "center", gap: 1, px: 2, py: 1,
//               bgcolor: "#DDF6EC", borderRadius: 2, minWidth: 160, justifyContent: "center"
//             }}>
//               <Grid sx={{ color: "#33B78E", fontSize: 20, display: "flex", alignItems: "center" }}>
//                 <WSIcons.VisibilityIcon />
//               </Grid>
//               <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
//                 Delivery Report
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Patient & Order Info */}
//       <Grid container spacing={2} mt={2}>
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
//               </Grid>
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.username}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
//               <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.contactNumber}</Typography></Grid>
              
//               <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
//               <Grid item xs={12} sm={9}>
//                 <Typography variant="body2">: {orderData.patient.address}</Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.totalItems}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.subtotal.toFixed(2)}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.payment.toUpperCase()}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Items</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2">: {itemsList}</Typography></Grid>
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* Report Status */}
//       {/* <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Report Status</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
//           <Grid item sm={2} xs={12}><Typography variant="body2" color="GrayText" mt={3}>Report</Typography></Grid>
//           <Grid item sm={10} xs={12}>
//             <WSFileUpload
//               name="galleryImages"
//               label=""
//               control={control as any}
//               rules={{ required: false }}
//               acceptFileTypes=".jpg,.jpeg,.png,.pdf"
//               maxFileSizeMB={5}
//               id="galleryImages"
//               image={true}
//               align="Start"
//               isToolTipImg={false}
//               multiple={true}
//             />
//           </Grid>
//         </Grid>
//       </Paper> */}

//       {/* Delivery Details */}
//       <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
//           <Grid item xs={12}><Divider /></Grid>
          
//          <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Assigned Technician:
//             </Typography>
//           </Grid>
//           {/* <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>#{orderData.deliveryDetails.technicianName}</Typography></Grid> */}
//   <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="technicianName"
//               name="technicianName"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianName}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
//           {/* ✅ Technician Status */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Technician Status:
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//              <WSTextField
//               control={control}
//               id="technicianStatus"
//               name="technicianStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.technicianStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
//           {/* ✅ Delivery Status */}
//           <Grid item xs={12} sm={4}>
//             <Typography variant="body2" color="GrayText" mt={2}>
//               Delivery Status:
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="deliveryStatus"
//               name="deliveryStatus"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryStatus}
//               sx={{ width: "200px" }}
//             />
//           </Grid>
          
          
//           <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography></Grid>
//           <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>#{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography></Grid>
          
//           <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography></Grid>
//           <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>:{new Date(orderData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
          
//           <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography></Grid>
//           <Grid item xs={12} sm={8}>
//             <WSTextField
//               control={control}
//               id="location"
//               name="location"
//               rules={{ required: true }}
//               label=""
//               defaultValue={orderData.deliveryDetails.deliveryAddress}
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Payment Information */}
//       <Grid container spacing={2} mt={3}>
//         <Grid item xs={12} sm={6}>
//           <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>: ₹{orderData.paymentInfo.orderPrice.toFixed(2)}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2" color="GrayText" mt={2}>: {orderData.paymentInfo.paymentMode}</Typography></Grid>
              
//               <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total</Typography></Grid>
//               <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold" mt={2}>: ₹{(orderData.paymentInfo.orderPrice + orderData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
//                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//               <Grid item xs={12} sm={8}> <Typography style={{ color: "#098963" }} mt={2}>Download</Typography></Grid>
//               {/* <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//                           <Grid item xs={12} sm={8}>
//                             <Typography style={{ color: "#098963" }}>Download</Typography>
//                           </Grid> */}
//             </Grid>
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* Hidden submit button */}
//       <button type="submit" style={{ display: 'none' }} />
//     </form>
//   );
// });








// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { useForm, UseFormReturn } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import config from "../../../Config/clientConfig.json";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import { PharmacyInvoiceReport } from "./invoice";

// // Updated TypeScript Interfaces to match actual API response
// interface Timeline {
//   orderPlaced: string;
//   deliveryAssigned: string | null;
//   orderShipped: string | null;
//   delivered: string | null;
//   status: string;
//   technician: string;
// }

// interface Patient {
//   username: string;
//   contactNumber: string;
//   address: string;
// }

// interface OrderInfo {
//   totalItems: number;
//   subtotal: number;
//   deliveryFee: number;
//   payment: string;
//   itemsName: string;
// }

// interface DeliveryDetails {
//   technicianName: string;
//   technicianStatus: string;
//   deliveryStatus: string;
//   orderId: string;
//   receivedDateTime: string | null;
//   locationUrl: string | null;
//   deliveryAddress: string;
// }

// interface PaymentInfo {
//   paymentStatus: string;
//   orderPrice: number;
//   deliveryPrice: number;
//   paymentMode: string;
//   invoiceUrl: string;
// }

// interface OrderData {
//   timeline: Timeline;
//   patient: Patient;
//   orderInfo: OrderInfo;
//   report: any | null;
//   deliveryDetails: DeliveryDetails;
//   paymentInfo: PaymentInfo;
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: OrderData;
// }

// // Extended FormData to include galleryImages for file upload
// interface FormData {
//   status: string;
//   action: string;
//   assigned: string;
//   collected: string;
//   test: string;
//   location: string;
//   galleryImages?: FileList | null;
// }

// export const PharmacyOrderDetails: React.FC = React.memo(() => {
//   const methods = useForm<FormData>({
//     defaultValues: {
//       status: "",
//       action: "",
//       assigned: "",
//       collected: "",
//       test: "",
//       location: "",
//       galleryImages: undefined
//     }
//   });
  
//   const { control, register, handleSubmit, setValue, reset } = methods;
//   const navigate = useNavigate();
//   const params = useParams<{ id: string }>();
//   const id = params?.id;

//   const [orderData, setOrderData] = useState<OrderData | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [error, setError] = useState<string>("");
  
//   // Modal state for invoice preview
//   const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);

//   // Fetch order data by ID
//   const fetchOrderData = useCallback(async () => {
//     if (!id) {
//       setError("No order ID provided");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       const response: ApiResponse = await callAPI(`pharmacy/Ph_Order_/order-details/${id}`, Method.GET);
//       console.log("the api response is csvb ", response);
      
//       if (response?.status && response?.data) {
//         setOrderData(response.data);
//         // Populate form with initial values
//         setTimeout(() => {
//           setValue("status", response.data.timeline.status);
//           setValue("location", response.data.deliveryDetails.deliveryAddress);
//         }, 100);
//       } else {
//         setError("Order not found");
//       }
//     } catch (err) {
//       console.error("Error fetching order:", err);
//       setError("Failed to fetch order details");
//     } finally {
//       setLoading(false);
//     }
//   }, [id, setValue]);

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { Orders: "pharmacy-orders/list" },
//       { [`Order #${id?.slice(-6).toUpperCase()}`]: `/pharmacy-orders/${id}` },
//     ]);
//   }, [id]);

//   // Handle invoice modal open
//   const handleOpenInvoice = () => {
//     setInvoiceModalOpen(true);
//   };

//   const onSubmit = async (data: FormData) => {
//     try {
//       const updateResponse = await callAPI(`pharmacy/Ph_Order_/order-details/${id}`, Method.PUT, data);
//       if (updateResponse.status) {
//         alert("Order updated successfully!");
//         fetchOrderData(); // Refresh data
//       }
//     } catch (error) {
//       console.error("Update failed:", error);
//       alert("Failed to update order");
//     }
//   };

//   // Dynamic timeline based on tracking
//   const timelineSteps = useMemo(() => {
//     const timelineData = orderData?.timeline;
//     const currentStatus = timelineData?.status?.toLowerCase() || "pending";
    
//     console.log("🔍 TIMELINE DEBUG:", {
//       status: timelineData?.status,
//       orderPlaced: !!timelineData?.orderPlaced,
//       deliveryAssigned: !!timelineData?.deliveryAssigned,
//       orderShipped: !!timelineData?.orderShipped,
//       delivered: !!timelineData?.delivered
//     });

//     const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
//     const isShipped = currentStatus.includes("shipped") || isDelivered;
//     const isAssigned = currentStatus.includes("assigned") || isShipped;
    
//     return [
//       { 
//         label: "Order Placed", 
//         completed: !!timelineData?.orderPlaced || isAssigned,
//         icon: <WSIcons.FiPackage /> 
//       },
//       { 
//         label: "Delivery Assigned", 
//         completed: !!timelineData?.deliveryAssigned || isAssigned,
//         icon: <WSIcons.TbUserSquareRounded /> 
//       },
//       { 
//         label: "Order Shipped", 
//         completed: !!timelineData?.orderShipped || isShipped,
//         icon: <WSIcons.RiRidingLine /> 
//       },
//       { 
//         label: "Delivered", 
//         completed: !!timelineData?.delivered || isDelivered,
//         icon: <WSIcons.BsArrowUpSquare /> 
//       },
//     ];
//   }, [orderData]);

//   const itemsList = orderData?.orderInfo?.itemsName || "";

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography>Loading order details...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (error || !orderData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
//         <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//           <Typography color="error">{error}</Typography>
//         </Paper>
//       </>
//     );
//   }

//   return (
//     <>
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

//         {/* Timeline Section */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
//             </Grid>
//             <Grid item xs={12}>
//               <WSHorizontalTimeline steps={timelineSteps} />
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Order Summary */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//           <Grid container spacing={2} mt={2}>
//             <Grid item sm={4} xs={12}>
//               <Typography variant="body2" color="GrayText">Order ID</Typography>
//             </Grid>
//             <Grid item sm={4} xs={12}>
//               <Typography variant="body2" color="GrayText">Technician Status</Typography>
//             </Grid>
//             <Grid item sm={2} xs={12}>
//               <Typography variant="body2" color="GrayText">Delivery status</Typography>
//             </Grid>
//             <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
            
//             <Grid item sm={4} xs={12}>
//               <Typography fontWeight="bold">#{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography>
//             </Grid>
//             <Grid item sm={4} xs={12}>
//               {/* <WSTextField
//                 control={control}
//                 id="technicianStatus"
//                 name="technicianStatus"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.technicianStatus}
//                 sx={{ width: "131px" }}
//               /> */}

//               <Typography variant="body2" > {orderData.deliveryDetails.technicianStatus}</Typography>
//             </Grid>
//             <Grid item sm={2} xs={12}>
//               {/* <WSTextField
//                 control={control}
//                 id="deliveryStatus"
//                 name="deliveryStatus"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.deliveryStatus}
//                 sx={{ width: "131px" }}
//               /> */}
//               <Typography variant="body2" >{orderData.deliveryDetails.deliveryStatus}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={2}>
//               <Grid 
//                 sx={{
//                   display: "flex", 
//                   alignItems: "center", 
//                   gap: 1, 
//                   px: 2, 
//                   py: 1,
//                   bgcolor: "#DDF6EC", 
//                   borderRadius: 2, 
//                   minWidth: 160, 
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   "&:hover": { bgcolor: "#C8F2DE" }
//                 }}
//                 onClick={handleOpenInvoice}
//               >
//                 <Grid sx={{ color: "#33B78E", fontSize: 20, display: "flex", alignItems: "center" }}>
//                   <WSIcons.VisibilityIcon />
//                 </Grid>
//                 <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
//                   Delivery Report
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Patient & Order Info - SAME AS ORIGINAL */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
//                 <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.username}</Typography></Grid>
//                 <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
//                 <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.contactNumber}</Typography></Grid>
//                 <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
//                 <Grid item xs={12} sm={9}>
//                   <Typography variant="body2">: {orderData.patient.address}</Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.totalItems}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.subtotal.toFixed(2)}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.payment.toUpperCase()}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Items</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {itemsList}</Typography></Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* Delivery Details - SAME AS ORIGINAL */}
//         <Paper elevation={0} style={{ padding: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
//             <Grid item xs={12}><Divider /></Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>Assigned Technician:</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               {/* <WSTextField
//                 control={control}
//                 id="technicianName"
//                 name="technicianName"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.technicianName}
//                 sx={{ width: "200px" }}
//               /> */}


//               <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.technicianName}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>Technician Status:</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               {/* <WSTextField
//                 control={control}
//                 id="technicianStatus"
//                 name="technicianStatus"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.technicianStatus}
//                 sx={{ width: "200px" }}
//               /> */}


//                <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.technicianStatus}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <Typography variant="body2" color="GrayText" mt={2}>Delivery Status:</Typography>
//             </Grid>
//             <Grid item xs={12} sm={8}>
//               {/* <WSTextField
//                 control={control}
//                 id="deliveryStatus"
//                 name="deliveryStatus"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.deliveryStatus}
//                 sx={{ width: "200px" }}
//               /> */}

//               <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.technicianStatus}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography variant="body2">: #{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography></Grid>
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography></Grid>
//             <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(orderData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
//             <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography></Grid>
//             <Grid item xs={12} sm={2}>
//               {/* <WSTextField
//                 control={control}
//                 id="location"
//                 name="location"
//                 rules={{ required: true }}
//                 label=""
//                 defaultValue={orderData.deliveryDetails.deliveryAddress}
//               /> */}
//               <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.deliveryAddress}</Typography>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Payment Information */}
//         <Grid container spacing={2} mt={3}>
//           <Grid item xs={12} sm={6}>
//             <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.orderPrice.toFixed(2)}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentMode}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total</Typography></Grid>
//                 <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold">: ₹{(orderData.paymentInfo.orderPrice + orderData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
//                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//                 <Grid item xs={12} sm={8}> 
//                   <Typography 
//                     style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }} 
//                     mt={2}
//                     onClick={handleOpenInvoice}
//                   >
//                     View Invoice
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         <button type="submit" style={{ display: 'none' }} />
//       </form>

//       {/* Invoice Modal */}
//       <Dialog 
//         open={invoiceModalOpen} 
//         onClose={() => setInvoiceModalOpen(false)}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{ sx: { height: "90vh" } }}
//       >
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <Typography variant="h6">Pharmacy Invoice</Typography>
//           <IconButton onClick={() => setInvoiceModalOpen(false)}>
//             <WSIcons.CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
//           {id && <PharmacyInvoiceReport bookingId={id} />}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// });

// PharmacyOrderDetails.displayName = "PharmacyOrderDetails";






import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { useForm, UseFormReturn } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
import config from "../../../Config/clientConfig.json";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { PharmacyInvoiceReport } from "./invoice";
import configData from "../../../Config/config.json";

// [KEEP ALL YOUR INTERFACES EXACTLY THE SAME - Timeline, Patient, OrderInfo, etc.]



const imgUrl = configData.imgUrl;
const getCorrectedReportUrl = (reportUrl: string) => {
  return reportUrl.replace(/^UploadedImages\//, '');
};

interface Timeline {
  orderPlaced: string;
  deliveryAssigned: string | null;
  orderShipped: string | null;
  delivered: string | null;
  status: string;
  technician: string;
}

interface Patient {
  username: string;
  contactNumber: string;
  address: string;
}

interface OrderInfo {
  totalItems: number;
  subtotal: number;
  deliveryFee: number;
  payment: string;
  itemsName: string;
}

interface DeliveryDetails {
  technicianName: string;
  technicianStatus: string;
  deliveryStatus: string;
  orderId: string;
  receivedDateTime: string | null;
  locationUrl: string | null;
  deliveryAddress: string;
}

interface PaymentInfo {
  paymentStatus: string;
  orderPrice: number;
  deliveryPrice: number;
  paymentMode: string;
  invoiceUrl: string;
}

interface OrderData {
  timeline: Timeline;
  patient: Patient;
  orderInfo: OrderInfo;
  report: any | null;
  deliveryDetails: DeliveryDetails;
  paymentInfo: PaymentInfo;
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: OrderData;
}

interface BillUploadFormData {
  file: FileList | null;
}

export const PharmacyOrderDetails: React.FC = React.memo(() => {
  const methods = useForm<BillUploadFormData>({
    defaultValues: {
      file: null
    }
  });
  
  const { control, handleSubmit, setValue, watch, formState } = methods;
  const fileInputRef = useRef<HTMLInputElement>(null);
  
  const navigate = useNavigate();
  const params = useParams<{ id: string }>();
  const id = params?.id;

  const [orderData, setOrderData] = useState<OrderData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [billUploadSuccess, setBillUploadSuccess] = useState(false);
  const [uploading, setUploading] = useState(false);

  const watchedFile = watch("file");

  // Fetch order data by ID (KEEP EXACTLY SAME)
  const fetchOrderData = useCallback(async () => {
    if (!id) {
      setError("No order ID provided");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError("");
      const response: ApiResponse = await callAPI(`pharmacy/Ph_Order_/order-details/${id}`, Method.GET);
      console.log("API response:", response);
      
      if (response?.status && response?.data) {
        setOrderData(response.data);
      } else {
        setError("Order not found");
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      setError("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOrderData();
  }, [fetchOrderData]);

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { Orders: "pharmacy-orders/list" },
      { [`Order #${id?.slice(-6).toUpperCase()}`]: `/pharmacy-orders/${id}` },
    ]);
  }, [id]);

  const handleOpenInvoice = () => {
    setInvoiceModalOpen(true);
  };

 
const handleBillUpload = async (data: BillUploadFormData) => {
  if (!id || !data.file || data.file.length === 0) {
    alert("Please select an invoice file to upload");
    return;
  }

  setUploading(true);
  
  const formData = new FormData();
  const selectedFile = data.file[0];
  formData.append("file", selectedFile);

  console.log("📤 UPLOADING:", selectedFile.name);

  try {
    // Your API returns undefined = SUCCESS ✅
     const response = await callAPI(
      `pharmacy/Ph_Order_/${id}/upload-invoice`,
      Method.POST,
      formData
    );
    console.log("the responbse is ",response);

    console.log("✅ UPLOAD SUCCESS (undefined response = normal)");
    setBillUploadSuccess(true);
    alert("Invoice uploaded successfully!");
    await fetchOrderData(); // Refresh to show new invoiceUrl
    
    // Clear form
    setValue("file", null as any);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    
  } catch (error: unknown) {
    console.error("❌ Upload error:", error);
    
    // ✅ TYPE-SAFE HTTP STATUS CHECK
    let isHttpSuccess = false;
    try {
      // Safely check if error has response.status
      const errorObj = error as any;
      if (errorObj?.response?.status === 200 || errorObj?.response?.status === 201) {
        isHttpSuccess = true;
      }
    } catch (e) {
      // Ignore - not an Axios-like error
    }

    if (isHttpSuccess) {
      console.log("✅ HTTP Success despite catch");
      setBillUploadSuccess(true);
      alert("Invoice uploaded successfully!");
      await fetchOrderData();
    } else {
      // ✅ TYPE-SAFE ERROR MESSAGE
      let errorMessage = "Try again";
      try {
        const errorObj = error as any;
        if (typeof errorObj?.message === 'string') {
          errorMessage = errorObj.message;
        }
      } catch (e) {
        // Use default message
      }
      alert("Upload failed: " + errorMessage);
    }
    
    // Always clear form
    setValue("file", null as any);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  } finally {
    setUploading(false);
    if (billUploadSuccess) {
      setTimeout(() => setBillUploadSuccess(false), 3000);
    }
  }
};



  const timelineSteps = useMemo(() => {
    const timelineData = orderData?.timeline;
    const currentStatus = timelineData?.status?.toLowerCase() || "pending";
    
    const isDelivered = currentStatus.includes("delivered") || currentStatus.includes("completed");
    const isShipped = currentStatus.includes("shipped") || isDelivered;
    const isAssigned = currentStatus.includes("assigned") || isShipped;
    
    return [
      { 
        label: "Order Placed", 
        completed: !!timelineData?.orderPlaced || isAssigned,
        icon: <WSIcons.FiPackage /> 
      },
      { 
        label: "Delivery Assigned", 
        completed: !!timelineData?.deliveryAssigned || isAssigned,
        icon: <WSIcons.TbUserSquareRounded /> 
      },
      { 
        label: "Order Shipped", 
        completed: !!timelineData?.orderShipped || isShipped,
        icon: <WSIcons.RiRidingLine /> 
      },
      { 
        label: "Delivered", 
        completed: !!timelineData?.delivered || isDelivered,
        icon: <WSIcons.BsArrowUpSquare /> 
      },
    ];
  }, [orderData]);

  const itemsList = orderData?.orderInfo?.itemsName || "";


  if (loading) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Typography>Loading order details...</Typography>
        </Paper>
      </>
    );
  }

  if (error || !orderData) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />
        <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      </>
    );
  }

  return (
    <>
      <div>
        <WSBackButton id="btnScheduleBack" url="/pharmacy-orders/list" />

        {/* Timeline Section */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Timeline</Typography>
            </Grid>
            <Grid item xs={12}>
              <WSHorizontalTimeline steps={timelineSteps} />
            </Grid>
          </Grid>
        </Paper>

        {/* Order Summary */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2} mt={2}>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2" color="GrayText">Order ID</Typography>
            </Grid>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2" color="GrayText">Technician Status</Typography>
            </Grid>
            <Grid item sm={2} xs={12}>
              <Typography variant="body2" color="GrayText">Delivery status</Typography>
            </Grid>
            <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
            
            <Grid item sm={4} xs={12}>
              <Typography fontWeight="bold">#{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography>
            </Grid>
            <Grid item sm={4} xs={12}>
              <Typography variant="body2">{orderData.deliveryDetails.technicianStatus}</Typography>
            </Grid>
            <Grid item sm={2} xs={12}>
              <Typography variant="body2">{orderData.deliveryDetails.deliveryStatus}</Typography>
            </Grid>
            {/* <Grid item xs={12} sm={2}>
              <Grid 
                sx={{
                  display: "flex", 
                  alignItems: "center", 
                  gap: 1, 
                  px: 2, 
                  py: 1,
                  bgcolor: "#DDF6EC", 
                  borderRadius: 2, 
                  minWidth: 160, 
                  justifyContent: "center",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "#C8F2DE" }
                }}
                onClick={handleOpenInvoice}
              >
                <Grid sx={{ color: "#33B78E", fontSize: 20, display: "flex", alignItems: "center" }}>
                  <WSIcons.VisibilityIcon />
                </Grid>
                <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1E8A67" }}>
                  Delivery Report
                </Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </Paper>

        {/* Patient & Order Info */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Patient Information</Typography>
                </Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Patient Name</Typography></Grid>
                <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.username}</Typography></Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Contact Number</Typography></Grid>
                <Grid item xs={12} sm={9}><Typography variant="body2">: {orderData.patient.contactNumber}</Typography></Grid>
                <Grid item xs={12} sm={3}><Typography variant="body2" color="GrayText">Address</Typography></Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">: {orderData.patient.address}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "19rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Order Information</Typography>
                </Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Total Items</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.totalItems}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Sub Total</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.subtotal.toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Delivery Fee</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.orderInfo.deliveryFee}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.orderInfo.payment.toUpperCase()}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Items</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {itemsList}</Typography></Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* 🔥 PHARMACY REPORT SECTION - EXACT ScanOrderDetails Pattern */}
<Grid container spacing={2} mt={2}>
  <Grid item xs={12}>
    <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
      <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
        🩺 Pharmacy Report Information
      </Typography>
      
      <Grid container spacing={1} sx={{ pl: 3, mb: 2, pt: 1 }}>
        {/* Report Label */}
        <Grid item xs={12} sm={3}>
          <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>
            Prescription Report:
          </Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
            Order Fulfillment Report
          </Typography>
        </Grid>

        {/* 🔥 EXACT LabOrderDetails REPORT VIEW */}
        {orderData.report && orderData.report.reportUrl && (
          <>
            <Grid item xs={12} sm={3}>
              <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>
                Report:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography 
                variant="body2"
                sx={{ 
                  fontSize: '0.9rem', 
                  color: "#098963", 
                  cursor: "pointer", 
                  textDecoration: "underline", 
                  '&:hover': { color: "#0a7a52" } 
                }}
                onClick={() => {
                  const filename = getCorrectedReportUrl(orderData.report.reportUrl);
                  const pdfUrl = `${imgUrl}/${filename}`;
                  console.log('📄 PharmacyReport - Opening:', pdfUrl);
                  
                  const newWindow = window.open(pdfUrl, '_blank', 'noopener,noreferrer');
                  if (!newWindow) {
                    alert('Please allow popups to view the report');
                  }
                }}
              >
                📄 View Report
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  </Grid>
</Grid>


        {/* Invoice Upload Section */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Invoice Upload</Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <form onSubmit={handleSubmit(handleBillUpload)}>
                <WSFileUpload
                  control={control as any}
                  name="file"
                  label="Upload Invoice"
                  id="file"
                />
                <Box mt={2}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!watchedFile || watchedFile.length === 0 || uploading}
                    sx={{ mt: 1 }}
                  >
                    {uploading ? "Uploading..." : "Upload Invoice"}
                  </Button>
                  {billUploadSuccess && (
                    <Typography color="success.main" sx={{ ml: 2 }}>
                      ✓ Invoice uploaded successfully
                    </Typography>
                  )}
                </Box>
              </form>
            </Grid>
            <Grid item xs={12} sm={6}>
              {orderData.paymentInfo.invoiceUrl && (
                <Box>
                  <Typography variant="body2" color="GrayText" mb={1}>
                    Uploaded Invoice:
                  </Typography>
                  <img
                    src={orderData.paymentInfo.invoiceUrl}
                    alt="Uploaded Invoice"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      border: "1px solid #ddd"
                    }}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Paper>

        {/* Delivery Details */}
        <Paper elevation={0} style={{ padding: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Delivery Details</Typography></Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Assigned Technician:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.technicianName}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Technician Status:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.technicianStatus}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="GrayText" mt={2}>Delivery Status:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>: {orderData.deliveryDetails.deliveryStatus}</Typography>
            </Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order ID</Typography></Grid>
            <Grid item xs={12} sm={8}><Typography variant="body2">: #{orderData.deliveryDetails.orderId.slice(-6).toUpperCase()}</Typography></Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Date</Typography></Grid>
            <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(orderData.timeline.orderPlaced).toLocaleString()}</Typography></Grid>
            <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Location</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="body2" mt={2}>:{orderData.deliveryDetails.deliveryAddress}</Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Payment Information */}
        <Grid container spacing={2} mt={3}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={0} style={{ padding: 20, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}><Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>Payment Information</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Status</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentStatus}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Order Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.orderPrice.toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Delivery Price</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: ₹{orderData.paymentInfo.deliveryPrice}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2">: {orderData.paymentInfo.paymentMode}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total</Typography></Grid>
                <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold">: ₹{(orderData.paymentInfo.orderPrice + orderData.paymentInfo.deliveryPrice).toFixed(2)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
                <Grid item xs={12} sm={8}> 
                  <Typography 
                    style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }} 
                    mt={2}
                    onClick={handleOpenInvoice}
                  >
                    View Invoice
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Invoice Modal */}
        <Dialog 
          open={invoiceModalOpen} 
          onClose={() => setInvoiceModalOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: { height: "90vh" } }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6">Pharmacy Invoice</Typography>
            <IconButton onClick={() => setInvoiceModalOpen(false)}>
              <WSIcons.CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
            {id && <PharmacyInvoiceReport orderId={id} />}

          </DialogContent>
        </Dialog>
      </div>
    </>
  );
});


